module.exports = __webpack_public_path__ + "img/pictoPeople7.f1555c4d.svg";